import React, { useState } from 'react';
import './style.css'
import { FillSearch } from '../Icons';
// Componente Search
const Search = ({ placeHolder, onChange }: any) => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (event: any) => {
        if (event && event.target) {
            setSearchTerm(event.target.value);
            onChange(event.target.value);
        }
    };

    return (
        <div className="search-container">
            <input type="text" value={searchTerm} onChange={handleSearchChange} placeholder={placeHolder} />
            <button className="search-button">
                <FillSearch />
            </button>
        </div>
    );
};

export default Search;
